<template>
    <div>       
        <div class="w-full flex flex-col">
            <div class="modal-header flex items-center justify-between cursor-move">
                <h1 class="flex-1 text-2xl">Edit Escalations</h1>
                <div @click="$modal.hide('edit-proposal-expense-escalations')">
                    <inline-svg name="close" classes="w-5 h-5 text-white fill-current cursor-pointer"></inline-svg>
                </div>
            </div>
            <div class="modal-toolbar h-16 flex items-center justify-between">
                <div class="flex flex-col">
                    <p class="font-semibold text-xl">{{ selectedProposalExpense.type.name }}</p>
                </div> 
            </div>  
		    <div class="p-5 flex items-center gap-x-8">
                <div class="w-full overflow-x-auto shadow">
                    <table id="escalations" class="relative w-full">
                        <thead>
                            <tr>
                                <th class="px-4 text-center">Year</th>
                                <th class="pr-6 text-center" v-for="year in selectedProposal.term" :key="year">{{ year }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="px-4"></td>
                                <td v-for="(year, yearIndex) in selectedProposal.term" :key="yearIndex">
                                    <div class="flex items-center">
                                        <input
                                            @input="setEscalation($event)"
                                            @blur="setPreviousEscalationInput($event)"
                                            :data-year="year"
                                            data-month="1"
                                            type="text"
                                            class="mx-auto form-input text-center"
                                            size="5" />
                                        <button v-if="year != selectedProposal.term" @click="escalateAcross" type="button">
                                            <inline-svg name="chevron-right" classes="w-5 w-6 text-blue-500 hover:text-blue-800 fill-current" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
			</div>
            <div class="bg-gray-100 p-4">
                <div class="flex items-center justify-end">
                    <button class="btn btn-secondary mr-2" @click.prevent="$modal.hide('edit-proposal-expense-escalations')">Close</button>
                    <div>
                        <button class="btn btn-green" @click.prevent="saveExpense">
                            <span v-if="loading">
                                <inline-svg name="loading-button"></inline-svg>                                
                            </span>
                            <span v-if="! loading">Save Escalations</span>
                        </button>
                    </div>
                </div>
            </div>
		</div>
		<notifications classes="notification" position="bottom right"></notifications>
	</div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    
    export default {
        data() {
            return { 
            	loading: false
            }
        },

        mounted() {
            this.selectedProposalExpense.escalations.forEach(escalation => {
                let input = document.querySelector(`input[data-year='${escalation.year_number}']`);

                input.value = escalation.amount;
            });
        },

        computed: {
            ...mapState(['projects']),
            ...mapState(['proposals']),
            ...mapGetters(['selectedProposal']),
            ...mapGetters(['selectedProposalExpense']),

            errors() {
            	return this.proposals.errors;
            }
        },

        methods: {
            setEscalation(event) {
                let year = parseInt(event.target.dataset.year);
                let month = parseInt(event.target.dataset.month);
                
                let escalationRecord = _.find(this.selectedProposalExpense.escalations, (row) => {
                    return row.year_number == year && row.month_number == month
                });

                if (escalationRecord) {
                    escalationRecord.amount = event.target.value;
                } else {
                    this.selectedProposalExpense.escalations.push({
                        expense_id: this.selectedProposalExpense.id,
                        year_number: year,
                        month_number: month,
                        amount: event.target.value
                    });
                }
            },

            setPreviousEscalationInput(event) {
                this.previousEscalationInput = event.target;
            },

            escalateAcross() {
                if (! this.previousEscalationInput) {
                    return;
                }

                let year = parseInt(this.previousEscalationInput.dataset.year);
                let inputs = document.querySelectorAll(`#escalations input`);

                for (var i = 0; i < inputs.length; ++i) {
                    if (parseInt(inputs[i].dataset.year) > year) {
                        inputs[i].value = this.previousEscalationInput.value;

                        inputs[i].dispatchEvent(new Event('input', { bubbles: true }));
                    }
                }
            },

            async saveExpense() {
                this.loading = true;

                await this.$store.dispatch('saveExpense').then(() => {
                    this.loading = false;

                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: "Escalations Saved"
                    });

                    this.$emit('save-proposal');

                    this.$modal.hide('edit-proposal-expense-escalations');
                });
            }
        }
    }
</script>